const MIXITUP_URL = 'https://cdn.jsdelivr.net/npm/mixitup@3.3.1/dist/mixitup.min.js';

/**
 * MixItUp is only needed by this block, so it is fetched here instead of from a
 * <script> tag on every page. Resolves once window.mixitup exists.
 */
function loadMixItUp() {
    if (typeof mixitup !== 'undefined') {
        return Promise.resolve();
    }
    return new Promise(function (resolve, reject) {
        const script = document.createElement('script');
        script.src = MIXITUP_URL;
        script.onload = resolve;
        script.onerror = function () { reject(new Error('MixItUp failed to load')); };
        document.body.appendChild(script);
    });
}

export function faqsFilter() {

    const container = document.querySelector('.faqs-filter .faqs-list');

    if (!container) {
        return;
    }

    loadMixItUp().then(function () { initFaqsFilter(container); }).catch(function (err) {
        console.error(err);
    });
}

function initFaqsFilter(container) {

    const $block = $(container).closest('.faqs-filter');
    const $items = $(container).find('.mix');
    //Each group exists twice: desktop sidebar and mobile dropdown, kept in sync by value
    const $topics = $block.find('.faqs-topics input[type=checkbox]');
    const $audiences = $block.find('.faqs-for input[type=checkbox]');
    const $search = $block.find('.faqs-search input');
    const $count = $block.find('.faqs-results-count');
    const $noResults = $block.find('.faqs-no-results');

    const mixer = mixitup(container, {
        animation: {
            duration: 300,
            effects: 'fade translateY(-20px)'
        },
        controls: {
            enable: false
        },
        callbacks: {
            onMixEnd: function(state) {
                $noResults.prop('hidden', state.totalShow !== 0);
            }
        }
    });

    function checkedValues($group) {
        const values = [];
        $group.filter(':checked').each(function() {
            if (values.indexOf(this.value) === -1) {
                values.push(this.value);
            }
        });
        return values;
    }

    function labelFor($group, value) {
        return $group.filter('[value="' + value + '"]').first().next('.form-check-label').text().trim();
    }

    //Selected checkboxes narrow within each group (OR) and combine across
    //groups and the search box (AND)
    function getMatches() {
        const topics = checkedValues($topics);
        const audiences = checkedValues($audiences);
        const query = String($search.val() || '').trim().toLowerCase();

        return $items.filter(function() {
            const $item = $(this);
            const topicOk = !topics.length || topics.some(value => $item.hasClass('topic-' + value));
            const audienceOk = !audiences.length || audiences.some(value => $item.hasClass('for-' + value));
            const queryOk = !query || $item.text().toLowerCase().indexOf(query) !== -1;
            return topicOk && audienceOk && queryOk;
        }).get();
    }

    function updateCount(total) {
        const labels = checkedValues($topics).map(value => labelFor($topics, value))
            .concat(checkedValues($audiences).map(value => labelFor($audiences, value)));

        const query = String($search.val() || '').trim();
        if (query) {
            labels.push(query);
        }

        const $line = $('<span></span>');
        $line.append($('<strong></strong>').text(total));
        $line.append(total === 1 ? ' result' : ' results');

        labels.forEach(function(label, i) {
            $line.append(i === 0 ? ' for ' : (i === labels.length - 1 ? ' and ' : ', '));
            $line.append($('<strong></strong>').text('“' + label + '”'));
        });

        $count.empty().append($line);
    }

    function applyFilters() {
        const matches = getMatches();
        updateCount(matches.length);
        mixer.filter(matches.length ? matches : 'none');
    }

    updateCount($items.length);

    $topics.add($audiences).on('change', function() {
        const $group = $(this).closest('.faqs-topics').length ? $topics : $audiences;
        //Mirror the change onto this value's counterpart in the other viewport
        $group.filter('[value="' + this.value + '"]').prop('checked', this.checked);
        applyFilters();
    });

    let searchTimer;
    $search.on('input', function() {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(applyFilters, 200);
    });

    //The mobile dropdown uses data-bs-auto-close="outside", so clicks inside it
    //(including the X and See Results) don't close it. Hide it explicitly.
    if (typeof bootstrap !== 'undefined') {
        $block.on('click', '.faqs-mobile-filters .dropdown-close, .faqs-mobile-filters .faqs-see-results', function(e) {
            e.preventDefault();
            const toggle = $(this).closest('.dropdown').find('.dropdown-toggle')[0];
            if (toggle) {
                bootstrap.Dropdown.getOrCreateInstance(toggle).hide();
            }
        });
    }

}
